import { href } from '../app/useHashRoute.js';

/** Footer links to the privacy notice and terms, shown wherever a player starts or signs up. */
export function LegalLinks({ className }: { className?: string }) {
  return (
    <nav aria-label="Legal" className={['legal-links', className].filter(Boolean).join(' ')}>
      <a href={href('privacy')}>Privacy notice</a>
      <span aria-hidden="true">·</span>
      <a href={href('terms')}>Terms of use</a>
    </nav>
  );
}
